import { Client, LookupItem } from "@amsanalytics/react-shared-library"
import {
  AdminAction,
  CREATE_CLIENT_PERFORMANCE_GROUP_SUCCESS,
  CREATE_CLIENT_SUCCESS,
  CREATE_NIADA_USER_SUCCESS,
  CREATE_USER_SUCCESS,
  DELETE_CLIENT_PERFORMANCE_GROUP_SUCCESS,
  GET_CLIENT_PERFORMANCE_GROUPS_SUCCESS,
  LOAD_CLIENTS_SUCCESS,
  LOAD_MODERATORS_SUCCESS,
  LOAD_PERFORMANCE_GROUPS_SUCCESS,
  LOAD_USERS_FOR_CLIENT_SUCCESS,
  LOAD_USERS_SUCCESS,
  REMOVE_NIADA_USER_SUCCESS,
  REMOVE_USER_SUCCESS,
  UPDATE_CLIENT_PERFORMANCE_GROUP_SUCCESS,
  UPDATE_CLIENT_SUCCESS,
  UPDATE_USER_SUCCESS
} from "./actions";
import { Reducer, combineReducers } from 'redux';
import { NiadaUser, User } from "../../Models/User";
import { reject } from "ramda";
import { ClientPerformanceGroup } from "../../Models/ClientPerformanceGroup";

export interface AdminState {
  clients: Client[];
  users: User[];
  moderators: NiadaUser[];
  performanceGroups: LookupItem[];
  clientPerformanceGroups: ClientPerformanceGroup[];
}
const INITIAL_STATE: AdminState = {
  clients: [],
  users: [],
  moderators: [],
  performanceGroups: [],
  clientPerformanceGroups: []
}

const clientsReducer = (state: Client[] = INITIAL_STATE.clients, action: AdminAction): Client[] => {
  switch (action.type) {
    case LOAD_CLIENTS_SUCCESS:
      return action.payload.clients;
    case CREATE_CLIENT_SUCCESS:
      return [...state, action.payload.client];
    case UPDATE_CLIENT_SUCCESS:
      return state.map(client => {
        if (client.id.toUpperCase() === action.payload.client.id.toUpperCase()) {
          return action.payload.client;
        }
        return client;
      });
    default:
      return state;
  }
}

const usersReducer = (state: User[] = INITIAL_STATE.users, action: AdminAction): User[] => {
  switch (action.type) {
    case LOAD_USERS_SUCCESS:
      return action.payload.users;
    case LOAD_USERS_FOR_CLIENT_SUCCESS:
      return action.payload.users;
    case CREATE_USER_SUCCESS:
      return [...state, action.payload.user];
    case UPDATE_USER_SUCCESS:
      return state.map(user => {
        if (user.adUserId?.toUpperCase() === action.payload.user.adUserId?.toUpperCase()) {
          return action.payload.user;
        }
        return user;
      })
    case REMOVE_USER_SUCCESS:
      return reject((u: User) => u.adUserId.toUpperCase() === action.payload.adUserId.toUpperCase(), state);
    case REMOVE_NIADA_USER_SUCCESS:
      return state.map(user => {
        if (user.adUserId.toUpperCase() === action.payload.adUserId.toUpperCase()) {
          return {
            ...user,
            isNIADAUser: false
          }
        }
        return user;
      })
    default:
      return state;
  }
}

const performanceGroupsReducer = (state: LookupItem[] = INITIAL_STATE.performanceGroups, action: AdminAction): LookupItem[] => {
  switch (action.type) {
    case LOAD_PERFORMANCE_GROUPS_SUCCESS:
      return action.payload.performanceGroups;
    default:
      return state;
  }
}

const clientPerformanceGroupsReducer = (state: ClientPerformanceGroup[] = INITIAL_STATE.clientPerformanceGroups, action: AdminAction): ClientPerformanceGroup[] => {
  switch (action.type) {
    case GET_CLIENT_PERFORMANCE_GROUPS_SUCCESS:
      return action.payload.clientPerformanceGroups;
    case CREATE_CLIENT_PERFORMANCE_GROUP_SUCCESS:
      return [...state, action.payload.clientPerformanceGroup];
    case UPDATE_CLIENT_PERFORMANCE_GROUP_SUCCESS:
      return state.map(cpg => {
        if (cpg.id === action.payload.clientPerformanceGroup.id) {
          return action.payload.clientPerformanceGroup;
        }
        return cpg;
      });
    case DELETE_CLIENT_PERFORMANCE_GROUP_SUCCESS:
      return reject((cpg: ClientPerformanceGroup) => cpg.id === action.payload.clientPerformanceGroupId, state);
    default:
      return state;
  }
}

const moderatorsReducer = (state: NiadaUser[] = [], action: AdminAction): NiadaUser[] => {
  switch (action.type) {
    case LOAD_MODERATORS_SUCCESS:
      return action.payload.users;
    default:
      return state;
  }
}


export const adminReducer: Reducer<AdminState> = combineReducers<AdminState>({
  clients: clientsReducer,
  users: usersReducer,
  moderators: moderatorsReducer,
  performanceGroups: performanceGroupsReducer,
  clientPerformanceGroups: clientPerformanceGroupsReducer
});